// Centralized constants/config for Salt Lake City Temple feature
// Update TEMPLE_BASE_PATH to change the root route for the experience
export const TEMPLE_BASE_PATH = '/saltlakecitytemple'
export const TEMPLE_GOOGLE_MAP_ID = 'b17f0f1987dbbff826ce36fd'
